import { type ZodType, z } from "zod";

import { OrderDirection } from "@/constants/orderDirection";

import { FilterKey, SortColumns, TabKey } from "./-constants";
import type { GetPeopleParams } from "./-query/type";

export const SearchSchema = z.object({
  menu: z.nativeEnum(TabKey).default(TabKey.EMPLOYEE),
  category: z.nativeEnum(FilterKey).default(FilterKey.EMPLOYEE_ALL),
  departmentIdIn: z.array(z.string()).optional(),
  positionIdIn: z.array(z.string()).optional(),
  jobTypeIdIn: z.array(z.string()).optional(),
  workerTypeIn: z.array(z.string()).optional(),
  placeIdIn: z.array(z.string()).optional(),
  sortColumn: z.enum(SortColumns).optional(),
  sortOrder: z.nativeEnum(OrderDirection).optional(),
  freeText: z.string().optional(),
  pageIndex: z.number().default(0),
  pageSize: z.number().default(100),
}) satisfies ZodType<GetPeopleParams>;

export type SearchSchema = z.infer<typeof SearchSchema>;
